import React from "react";
import { useTranslation } from "react-i18next";
import ExpertisePageTemplate from "../components/ExpertisePageTemplate";

export default function AdvancedAnalyticsPage() {
  const { t } = useTranslation();
  const data = t("pillarPages.advancedAnalytics", { returnObjects: true });

  return (
    <ExpertisePageTemplate
      pageKey="advanced-analytics"
      data={data}
      mediaSlotLabel={t("aboutPage.media.slot")}
      primaryHref="/contact"
    />
  );
}
